<template>
  <div>
    <div class="flex justify-between">
      <label
        v-if="label"
        v-text="label"
        :for="$id('basic-input')"
        class="block text-sm font-medium leading-5 text-gray-700"
      />
      <slot name="cornerHint" />
      <span v-if="cornerHint" class="text-sm leading-5 text-gray-500" v-text="cornerHint"></span>
    </div>

    <div class="mt-1 relative rounded-md shadow-sm">
      <input
        :id="$id('basic-input')"
        ref="input"
        v-bind="$attrs"
        v-on="inputListeners"
        :class="[{'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red': hasError}, inputClass]"
        class="form-input block w-full sm:text-sm sm:leading-5 disabled:opacity-50 disabled:bg-gray-100"
      />
      <slot />
    </div>
    <p class="mt-2 text-sm text-gray-500" v-if="hint" v-text="hint" />

    <p class="mt-2 text-sm text-red-600" v-if="hasError" v-text="error[0]" />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    label: {
      required: false,
      type: String
    },
    cornerHint: {
      required: false,
      type: String
    },
    hint: {
      required: false,
      type: String
    },
    inputClass: {
      required: false,
      type: String
    },
    error: {
      required: false,
      default: null
    }
  },

  computed: {
    inputListeners: function() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event.target.value);
          }
        }
      );
    },
    hasError() {
      return !!this.error;
    }
  }
};
</script>